<template>
  <div>
    <div v-if="tutorial !== -1">
      <v-card outlined class="py-2 px-sm-3" elevation="2">
        <!-- Subscribed -->
        <v-card flat>
          <v-card-text class="text-center">
            <div
              class="text-h5 font-weight-medium text--primary"
              style="opacity: 0.8"
            >
              {{ tutorial.name }}
            </div>
          </v-card-text>
          <v-card-text class="mb-0">
            <v-container class="text-caption font-weight-regular">
              <v-row class="d-flex justify-center align-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-icon dense class="pr-1">mdi-account</v-icon>
                      {{ tutorial.responsible_tutor }}
                    </div>
                  </template>
                  <span>Tutor</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-icon dense class="pr-1 pl-7">mdi-chart-bar</v-icon>
                      {{ formatCap(tutorial.capacity) }}
                    </div>
                  </template>
                  <span>Kapazität</span>
                </v-tooltip>

                <v-tooltip top v-if="tutorial.format === 'PRESENCE'">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-icon dense class="pr-1 pl-7">mdi-map-marker</v-icon>
                      {{ tutorial.room || "nicht angegeben" }}
                    </div>
                  </template>
                  <span>Raum</span>
                </v-tooltip>
                <div v-else class="d-flex">
                  <a :href="tutorial.link" target="_blank">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <v-icon dense class="pr-1 pl-7">mdi-link</v-icon>
                          <span class="link">{{
                            tutorial.link || "nicht angegeben"
                          }}</span>
                        </div>
                      </template>
                      <span>Link</span>
                    </v-tooltip>
                  </a>
                  <v-tooltip top v-if="tutorial.link_password">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-icon dense class="pr-1 pl-7">mdi-lock</v-icon>
                        {{ tutorial.link_password || "nicht angegeben" }}
                      </div>
                    </template>
                    <span>Raumzugangscode</span>
                  </v-tooltip>
                </div>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-icon dense class="pr-1 pl-7">mdi-clock</v-icon>
                      {{ tutorial.start }} - {{ tutorial.end }}
                    </div>
                  </template>
                  <span>Uhrzeit</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-icon dense class="pr-1 pl-7">mdi-check-bold</v-icon>
                      {{ formatFormat(tutorial.format) }}
                    </div>
                  </template>
                  <span>Format</span>
                </v-tooltip>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-text style="">
            <v-row no-gutters class="d-flex justify-center">
              <v-btn
                small
                outlined
                color="tertiary"
                @click="toTutorialSelctionView"
                class="ma-1"
              >
                <v-icon left> mdi-pencil </v-icon>
                Ändern
              </v-btn>
              <v-btn
                small
                outlined
                @click="exportICal"
                color="#777777"
                class="ma-1"
              >
                <v-icon left>mdi-cloud-download</v-icon>
                Export
              </v-btn>
              <v-btn
                small
                outlined
                color="alert"
                @click="deleteCurrentTutorial"
                class="ma-1"
              >
                <v-icon left> mdi-trash-can </v-icon>
                Löschen
              </v-btn>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
        </v-card>

        <Timeline :tutorSessions="tutorSessions"></Timeline>
      </v-card>
    </div>
    <!-- Not Subscribed -->
    <div v-else>
      <v-card elevation="2" class="text-center">
        <v-card-text>
          <div class="text-caption">Mein Tutorium</div>
          <v-divider></v-divider>
          <img :src="noSubscriptionImage" />
          <div class="text-caption pt-3 text--secondary">
            Es ist noch kein Tutorium abonniert.
          </div>
        </v-card-text>
        <v-card-actions class="pt-0 px-5 mb-1">
          <v-spacer></v-spacer>
          <v-btn
            block
            depressed
            color="tertiary"
            class="white--text"
            @click="toTutorialSelctionView"
          >
            Abonnieren
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref } from "@vue/composition-api";
import Timeline from "@/components/Timeline.vue";
import ProfileView from "@/views/ProfileView.vue";

export default defineComponent({
  name: "StudentTutorialView",
  setup(props, { root }) {
    const tutorial = ref(-1);

    const tutorSessions = ref([]);
    root.$axios
      .get("tutorials/subscribed")
      .then((req) => {
        tutorial.value = req.data;
        root.$axios.get("tutor_sessions/subscribed/").then((req) => {
          tutorSessions.value = req.data.sort(function (a, b) {
            return new Date(a.date) - new Date(b.date);
          });
        });
      })
      .catch((err) => {
        if (
          err.response.status == 404 &&
          err.response.data == "no tutorial subscribed"
        ) {
          tutorial.value = -1;
        }
      });

    const deleteCurrentTutorial = () => {
      if (window.confirm("current subscribed tutorial will be removed")) {
        root.$axios.delete("tutorials/subscribed").then(() => {
          tutorial.value = -1;
          window.alert("success");
        });
      }
    };

    const toTutorialSelctionView = () => {
      root.$router.push({
        name: "tutorials.my-tutorial.select",
        params: { tutorialId: tutorial.value == -1 ? -1 : tutorial.value.id },
      });
    };

    return {
      tutorSessions,
      deleteCurrentTutorial,
      toTutorialSelctionView,
      tutorial,
    };
  },
  components: {
    ProfileView,
    Timeline,
  },
  data() {
    return {
      noSubscriptionImage: require("../assets/Images/undraw/no_subscription.svg"),
    };
  },
  methods: {
    exportICal() {
      for (let i = 0; i < this.tutorSessions.length; i++) {
        const session = this.tutorSessions[i];
        const startDate = this.getDate(session.date, session.start);
        const endDate = this.getDate(session.date, session.end);
        if (startDate && endDate) {
          this.$ics.addEvent(
            "de",
            "GBS Übung",
            this.tutorial.name,
            this.tutorial.room ? this.tutorial.room : "",
            startDate,
            endDate,
            this.tutorial.link ? this.tutorial.link : ""
          );
        }
      }
      this.$ics.download(this.tutorial.name);
      this.$ics.removeAllEvents();
    },
    getDate(sessionDate, sessionTime) {
      // get date
      let d = new Date(sessionDate);
      if (d == "Invalid Date") return null;

      // get time
      d = d.setHours(sessionTime.split(":")[0]);
      if (isNaN(d)) return null;

      return d;
    },
    formatCap(c) {
      if (c === "NOT_CROWDED") {
        return "kaum besucht";
      } else if (c === "NORMAL") {
        return "normal besucht";
      } else if (c === "CROWDED") {
        return "stark besucht";
      } else if (c === "BUSY") {
        return "voll";
      } else {
        return "unbekannt besucht";
      }
    },
  },
});
</script>

<style scoped>
button {
  margin-right: 5px;
  float: right;
  background-color: transparent;
}

.buttonlist {
  width: 100%;
  margin-bottom: 10px;
}

.my-tutorial-card {
  padding: 1rem 3rem 1.5rem 3rem;
}

.my-tutorial-card .v-list-item {
  padding: 0;
}

.my-tutorial-card .v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 15px;
}

.v-image {
  margin: 0 2rem;
}

.v-card__text {
  padding: 1rem;
}

img {
  max-width: 35%;
  min-width: 200px;
}
</style>
